export default "__VITE_ASSET__a555cbd8__"